import { render, staticRenderFns } from "./Shortkey.vue?vue&type=template&id=2ffb0fb7&"
import script from "./Shortkey.vue?vue&type=script&lang=js&"
export * from "./Shortkey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports